export default __webpack_public_path__ + "static/media/dashboardbg.e8031c09.png";